import { render } from "./ProfDocument.vue?vue&type=template&id=642bcd30"
import script from "./ProfDocument.vue?vue&type=script&lang=js"
export * from "./ProfDocument.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__